/** Returns the correct padding class for content below the ticker.
 *  Two-row ticker (global + local) needs more padding than single-row. */
export function getTickerPadding(hasGlobalTicker: boolean, hasLocalTicker: boolean = false): string {
  if (!hasGlobalTicker) return 'pt-14';
  if (hasLocalTicker) return 'pt-[5.75rem]';
  return 'pt-[4.75rem]';
}
